import type { TOC } from '@ember/component/template-only'
import type InvalidRoute from 'teacher-ui-client/manage/import/students/invalid/route'
import type InvalidController from 'teacher-ui-client/manage/import/students/invalid/controller'
import { InlineAlert, AlertType, InlineAlertTitle } from 'teacher-ui-client/components/inline-alert'
import { t } from 'ember-intl'
import { on } from '@ember/modifier'
import { pick } from 'teacher-ui-client/helpers/pick'
import { UiButtonLink } from 'teacher-ui-client/components/ui-button/link'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import RouteTemplate from 'ember-route-template'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

interface Signature {
  Args: {
    model: ModelFor<InvalidRoute>
    controller: InvalidController
  }
}
export const ManageImportStudentsInvalidPage: TOC<Signature> = <template>
  <InlineAlert @type={{AlertType.Warning}} role="alert">
    <InlineAlertTitle>
      {{t "manage.studentCsv.errorInlineFlash" htmlSafe=true}}
    </InlineAlertTitle>
  </InlineAlert>

  <table class="mt-4 w-full">
    <thead>
      <tr class="import-table-header">
        <th class="import-table-cell import-table-header-cell w-16"></th>
        <th class="import-table-cell import-table-header-cell w-48 text-center">{{t
            "manage.bulkActions.csv.lineNo"
          }}</th>
        <th class="import-table-cell import-table-header-cell border-0">{{t
            "manage.bulkActions.csv.rowErrorHeading"
          }}</th>
      </tr>
    </thead>
    <tbody class="import-table-body">
      {{#each @model.errors as |error index|}}
        <tr class="table-row-striped" data-test-error-row={{index}}>
          <td class="import-table-cell import-table-body-cell text-center">
            <PhosphorIcon @icon="phosphor-warning-fill" class="text-watermelony-red-350" />
          </td>
          <td class="import-table-cell import-table-body-cell text-center" data-test-error-csv-line-cell>
            {{#if error.csvRow}}
              {{error.csvRow}}
            {{else}}
              {{t "na"}}
            {{/if}}
          </td>
          <td class="import-table-cell import-table-body-cell" data-test-error-msg-cell>
            {{error.detail}}
          </td>
        </tr>
      {{/each}}
    </tbody>
  </table>

  <div class="mt-8">
    <label for="upload-csv-invalid" data-test-upload-students-csv>
      <input
        id="upload-csv-invalid"
        class="hidden"
        type="file"
        accept="text/csv, .csv"
        {{on "change" (pick "target.files" @controller.selectCsvFile)}}
      />
      <UiButtonLink class="whitespace-nowrap" @appearance={{ButtonAppearance.regular}}>
        {{t "manage.bulkActions.csv.reupload"}}
      </UiButtonLink>
    </label>
  </div>
</template>

export default RouteTemplate(ManageImportStudentsInvalidPage)
